import Filter from './filters/filter';
import FilterGroup from './filters/filterGroup';

export default class PanelOverviewController {
    constructor() {
        this.container = null;
        this.filters = [];
        this.filterGroup = null;

        if (document.querySelector('section.panelOverview')) {
            this.container = document.querySelector('section.panelOverview');
            this.inti();
        }
    }

    inti() {
        this.container.querySelectorAll('.filterInput').forEach(filterElement => {
            let filter = new Filter(filterElement);
            filter.expandable = false; // Handles by Selectric
            filter.init();

            this.filters.push(filter);
        });

        this.filterGroup = new FilterGroup(this.filters, this.container.querySelectorAll('.itemColumn'));
        this.filterGroup.init();
    }
}